import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { SignInForm } from "@/shared/auth";

export const Route = createFileRoute("/sign-in")({
  beforeLoad: ({ context }) => {
    if (context.auth.status === "authenticated") throw redirect({ to: "/" });
  },
  component: SignInScreen,
});

function SignInScreen() {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();

  return (
    /*
      `--keyboard-height` is published by the platform seam. Without lifting by it, the
      submit button of this exact form sits under the iOS keyboard — the single most
      reported "the app is broken" on any sign-up screen.
    */
    <main
      className="scroll-area flex flex-1 flex-col justify-center px-6 py-10"
      style={{ paddingBottom: "calc(2.5rem + var(--keyboard-height))" }}
    >
      <div className="mx-auto w-full max-w-sm">
        <h1 className="text-display">{t("title")}</h1>
        <p className="text-row text-muted-foreground mb-7">{t("subtitle")}</p>
        <SignInForm onDone={() => void navigate({ to: "/" })} />
      </div>
    </main>
  );
}
